import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Footer() {
  const { config, site } = useAuth();
  const phones = (site.phone || "").split(/[·,]/).map((s) => s.trim()).filter(Boolean);
  return (
    <footer className="bg-slate-900 grain relative mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="max-w-sm">
            <div className="flex items-center gap-3 mb-3">
              <img src="/logo.png" alt="Zealous Ventures" className="h-11 w-auto bg-white rounded-lg p-1.5" />
              <div>
                <div className="font-heading font-extrabold text-white text-lg">
                  {config.business_name || "Zealous Ventures"}
                </div>
                <div className="text-[11px] uppercase tracking-widest text-[#FFDA00] font-semibold">
                  {site.footer_tagline}
                </div>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              {site.footer_about}
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-12 text-sm min-w-0 [&>*]:min-w-0 break-words">
            <div>
              <div className="font-semibold text-white mb-3">Company</div>
              <ul className="space-y-2 text-slate-400">
                <li>About us</li>
                <li>Contact</li>
                <li>Terms</li>
              </ul>
            </div>
            <div>
              <div className="font-semibold text-white mb-3">Contact</div>
              <ul className="space-y-2 text-slate-400">
                <li className="flex items-start gap-2">
                  <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                  <span>{site.address}</span>
                </li>
                <li className="flex items-center gap-2"><Phone className="h-4 w-4 shrink-0" /> {site.phone}</li>
                <li className="flex items-center gap-2"><Mail className="h-4 w-4 shrink-0" /> {site.email}</li>
                <li className="flex items-center gap-2"><Clock className="h-4 w-4 shrink-0" /> {site.timing}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 text-xs text-slate-500">
          © {new Date().getFullYear()} {config.business_name || "Zealous Ventures"} · GSTIN {site.gstin} · distributors of 25+ brands. All prices exclusive of applicable taxes.
        </div>
      </div>
    </footer>
  );
}
